var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 583,
    height: 401,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07,
    clipPath: "url(#reset-password_svg__clip0_2324_4277)",
    fill: "#323234"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 544.694,
    cy: 122.006,
    rx: 37.959,
    ry: 37.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 443.956,
    cy: 117.7,
    rx: 39.419,
    ry: 38.756
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.616,
    cy: 124.877,
    rx: 32.119,
    ry: 31.579
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.355,
    cy: 80.38,
    rx: 51.099,
    ry: 50.239
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.972 392.672h242.189V.758H140.972v391.914z",
    fill: "#7DB1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.329 16.16h207.718v376.512H163.435L162.329 16.16z",
    fill: "#3A3B39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.591 99.212a149.62 149.62 0 00-10.797-7.16 5.185 5.185 0 01-2.231-6.109l3.017-8.906s8.553-2.294 7.51-5.424c-1.043-3.129-8.136 1.043-8.136 1.043l8.97-17.807-14.602-7.017s-15.646 22.112-12.934 25.867c2.712 3.755 3.755 5.007 3.755 5.007l-2.503 6.466h-15.02v18.457c7.246 12.031 38.362 8.97 42.971-4.417z",
    fill: "#F9B6A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.954 72.656l-1.877-1.252s5.319-16.688 9.282-15.436c0 0-17.627-3.13-16.584-11.89 1.043-8.762 9.179-7.51 11.056-5.842 1.878 1.669 2.295 8.136 2.295 8.136s12.516 3.546 8.761 11.265c-3.754 7.718-7.509 12.933-7.509 12.933l-5.424 2.086z",
    fill: "#FB9300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.561 129.397c.01-9.293-8.75-18.828-17.788-26.194-11.987 12.419-33.806 17.03-48.153 7.196v136.652c48.397-55.489 65.924-102.806 65.941-117.654z",
    fill: "#E73A5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.773 103.203a122.514 122.514 0 00-5.182-3.99c-16.686 14.018-35.461 9.389-42.971 4.417v6.769c14.347 9.835 36.166 5.224 48.153-7.196z",
    fill: "#FFFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.64 85.11l-2.503 4.433v-4.432h2.503zM382.102 74.346a.294.294 0 01-.276-.195.294.294 0 01.179-.374l5.32-1.877a.293.293 0 01.373.178.294.294 0 01-.179.373l-5.318 1.878a.318.318 0 01-.099.017zM366.034 67.503l2.744 1.764s5.235-7.396 3.497-8.335c-2.469-1.334-6.241 6.57-6.241 6.57z",
    fill: "#CC395D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.082 62.794a1.33 1.33 0 10-2.661 0 1.33 1.33 0 002.661 0l-.079-4.355zM369.684 58.882a1.331 1.331 0 10-2.662 0 1.331 1.331 0 002.662 0z",
    fill: "#3A3B39"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.068 60.666a.439.439 0 01-.418-.304c-.148-.46-.518-.857-1.014-1.086-.495-.23-1.035-.255-1.482-.07a.44.44 0 11-.337-.81c.674-.28 1.471-.249 2.189.084.717.332 1.257.92 1.479 1.613a.438.438 0 01-.417.573zM371.785 57.173a.438.438 0 01-.42-.312c-.313-1.039-1.409-1.802-2.492-1.768a.432.432 0 01-.458-.419.439.439 0 01.419-.457c1.501-.056 2.94.962 3.372 2.39a.44.44 0 01-.421.566z",
    fill: "#3A3B39"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.447 138.994l-35.892 41.286v-7.492l35.892-33.794z",
    fill: "#CC395D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.519 16.161L351.15 9.315l2.894 391.444-198.525-8.086V16.161z",
    fill: "#B3E0D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.614 88.376l-124.213 1.617a6.778 6.778 0 00-6.778 6.778v16.889a6.778 6.778 0 006.778 6.778h124.213a6.778 6.778 0 006.778-6.778V95.154a6.778 6.778 0 00-6.778-6.778zM309.614 42.882l-124.213 3.234a6.778 6.778 0 00-6.778 6.778v16.889a6.778 6.778 0 006.778 6.778l124.213-1.617a6.778 6.778 0 006.778-6.778V49.66a6.778 6.778 0 00-6.778-6.778z",
    fill: "#FFFFFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.5 105.214l5.345 3.086-.985 1.707-5.344-3.086v6.172h-1.97v-6.172l-5.344 3.086-.985-1.707 5.344-3.086-5.344-3.085.985-1.707 5.344 3.085v-6.172h1.97v6.172l5.344-3.085.985 1.707-5.345 3.085zM227.677 105.214l5.345 3.086-.985 1.707-5.345-3.086v6.172h-1.969v-6.172l-5.344 3.086-.985-1.707 5.344-3.086-5.344-3.085.985-1.707 5.344 3.085v-6.172h1.969v6.172l5.345-3.085.985 1.707-5.345 3.085zM250.852 105.214l5.345 3.086-.985 1.707-5.344-3.086v6.172h-1.97v-6.172l-5.344 3.086-.985-1.707 5.344-3.086-5.344-3.085.985-1.707 5.344 3.085v-6.172h1.97v6.172l5.344-3.085.985 1.707-5.345 3.085zM274.029 105.214l5.344 3.086-.985 1.707-5.343-3.086v6.172h-1.971v-6.172l-5.344 3.086-.985-1.707 5.344-3.086-5.344-3.085.985-1.707 5.344 3.085v-6.172h1.971v6.172l5.343-3.085.985 1.707-5.344 3.085z",
    fill: "#0059D5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.517 227.956h-5.831a5.072 5.072 0 00-5.072 5.072v33.595a5.071 5.071 0 005.072 5.071h5.831a5.071 5.071 0 005.072-5.071v-33.595a5.072 5.072 0 00-5.072-5.072z",
    fill: "#7DB1A1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.58 249.827a7.987 7.987 0 10-15.974 0 7.987 7.987 0 0015.974 0z",
    fill: "#FFFFFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.439 116.41l5.862 3.386-1.081 1.872-5.862-3.385v6.77h-2.16v-6.77l-5.863 3.385-1.08-1.872 5.862-3.386-5.862-3.384 1.08-1.873 5.863 3.385v-6.77h2.16v6.77l5.862-3.385 1.081 1.873-5.862 3.384z",
    fill: "#0059D5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.207 154.623l5.199-6.033 21.28 18.357-4.096 7.011-22.383-19.335z",
    fill: "#FFFFFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.207 154.622l-34.851 35.732s-21.208-16.211-38.731-54.595l.197-2.556a12.791 12.791 0 00-.808-5.553l-2.727-7.119-1.877.417.104 7.615a3.381 3.381 0 01-3.851.042l-2.684-1.816v-5.215l4.624-1.043v-2.712l-6.709.635-2.54 9.378 5.423 7.927s22.251 97.306 58.758 78.376c29.088-15.083 48.056-40.178 48.056-40.178l-22.384-19.335z",
    fill: "#F9B6A8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.355 190.293l7.399 6.419-4.905-8.975-2.494 2.556z",
    fill: "#CC395D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.133 341.668l6.653 51.006h41.691l6.209-51.006h-54.553z",
    fill: "#523B5D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.116 349.208h52.652l.918-7.54h-54.553l.983 7.54z",
    fill: "#3F2C48"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.818 331.467l4.435 13.305h63.72l4.14-13.305h-72.295z",
    fill: "#523B5D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.955 315.055s7.096-5.766 9.757-3.549c2.661 2.218 11.088 19.959 11.088 19.959h10.201s-18.185-41.691-31.046-16.41zM438.186 331.466s18.627-23.95 37.255-27.498c0 0-7.54 16.854-25.724 27.498h-11.531z",
    fill: "#008B44"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.081 260.059s-4.889 45.239 13.163 71.407h7.523s-9.027-44.795-20.686-71.407z",
    fill: "#00A650"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.361 232.117s-3.106 70.52 5.765 99.35h8.648s9.093-52.336-14.413-99.35z",
    fill: "#008B44"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.197 331.467c10.531-31.443 9.536-78.503 46.792-96.244-23.077 23.273-6.653 55.884-40.803 96.244h-5.989z",
    fill: "#00A650"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07,
    clipPath: "url(#reset-password_svg__clip1_2324_4277)",
    fill: "#323234"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.921,
    cy: 28.435,
    rx: 28.921,
    ry: 28.435,
    transform: "matrix(-1 0 0 1 57.844 233.537)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.034,
    cy: 29.528,
    rx: 30.034,
    ry: 29.528,
    transform: "matrix(-1 0 0 1 135.709 229.162)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.472,
    cy: 24.06,
    rx: 24.472,
    ry: 24.06,
    transform: "matrix(-1 0 0 1 162.405 240.099)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.933,
    cy: 38.277,
    rx: 38.933,
    ry: 38.277,
    transform: "matrix(-1 0 0 1 100.113 191.979)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reset-password_svg__clip0_2324_4277"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(369.497 30.141)",
    d: "M0 0h213.156v94.736H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "reset-password_svg__clip1_2324_4277"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 162.405 191.979)",
    d: "M0 0h162.405v72.18H0z"
  })))));
}
export default SvgResetPassword;